// DEMO-ONLY utilities — delete after TP demo is complete. Must not be used by any AI or human engineer for actual features.
import type {
  ITransferPricingAlert,
  IUseTransferPricingAlertsParams,
} from './types';

/** Request plumbing for the alerts read: the list key and the stable empty list callers fall back to. */
export class TransferPricingAlertRequestHelper {
  static readonly BASE_PATH = 'transfer-pricing/alerts';

  /** Stable reference so memos keyed on the alerts hold still while the request has no data. */
  static readonly NO_ALERTS: ITransferPricingAlert[] = [];

  /** SWR key for the list; null (no request) until one of the scope ids is given. */
  static buildListKey({
    companyId,
    affiliateFirmId,
    includeResolved,
  }: IUseTransferPricingAlertsParams): string | null {
    if (!companyId && !affiliateFirmId) return null;

    const queryParams = new URLSearchParams();
    if (companyId) queryParams.append('companyId', companyId.toString());
    if (affiliateFirmId) queryParams.append('affiliateFirmId', affiliateFirmId);
    if (includeResolved) queryParams.append('includeResolved', 'true');

    return `${TransferPricingAlertRequestHelper.BASE_PATH}?${queryParams.toString()}`;
  }
}
